import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  IconButton,
  Box,
  Divider,
  Avatar
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import EditNoteIcon from '@mui/icons-material/EditNote';
import { useNavigate } from "react-router";
import SkeletonList from "../../sections/SkeletonList";
import SkeletonCard from "../../sections/SkeletonCard";

const MetaDataConsumer = ({ metadata }) => {

    const navigate = useNavigate();

    const values = metadata?.org_metadata?.values || [];
  
    return (
      <Box sx={{ padding: 3 }}>
        <Grid container spacing={3}>
          {values.map((item, idx) => (
            <Grid item xs={12} md={6} lg={4} key={idx}>
              <Card
                sx={{
                  borderRadius: 3,
                  boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                  transition: "0.3s",
                  "&:hover": { boxShadow: "0 4px 20px rgba(0,0,0,0.2)" },
                }}
              >
                <CardContent>
                  {/* Header with title + edit button */}
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Typography variant="h6" fontWeight="bold" noWrap>
                      {item.title || "Untitled"}
                    </Typography>
  
                    <IconButton
                      color="primary"
                      size="small"
                      onClick={() =>
                        navigate("/staff/organisation/metadata/view/", {
                          state: { single_value: {val:item,index:idx} },
                        })
                      }
                    >
                      <EditNoteIcon />
                    </IconButton>
                  </Box>
  
                  <Divider sx={{ my: 1 }} />
  
                  {/* Thumbnail + text */}
                  <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
                    <Avatar
                      src={item.img}
                      variant="rounded"
                      sx={{ width: 64, height: 64, borderRadius: 2 }}
                    />
  
                    <Box>
                      <Typography variant="body1" fontWeight={500} noWrap>
                        {item.text}
                      </Typography>
  
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ width: "180px" }}
                        noWrap
                      >
                        {item.value}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  }

export default MetaDataConsumer;
